import { User } from '../../Models/user';

export const USERPROFILE: User =
{
  fName: null,
  lName: null,
  active: null,
  currentbranch: null,
  id: null,
  userId: null,
  inviteCode: null,
  nationalCode: null,
  phoneNumber: null,
  picture: null,
  fullName: null,
  userName: null,
  roles: null,
  isBranchAdmin: null,
  appName: 'niazmandan',
  mightyServesCount: null,
  firstName: null,
  lastName: null,
  email: null,
  address: null,
  profilePicUrl: null,
  lockoutEnabled: null,
}

